const PhotoIcon = ({ viewBox = "0 0 20 20", className = "hayley-h-5 hayley-w-5 hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path d="M0.625 15.625L4.375 11.875L6.875 14.375L13.125 8.125L19.375 14.375" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M17.5 19.375H2.5C2.00272 19.375 1.52581 19.1775 1.17417 18.8258C0.822544 18.4742 0.625 17.9973 0.625 17.5V2.5C0.625 2.00272 0.822544 1.52581 1.17417 1.17417C1.52581 0.822544 2.00272 0.625 2.5 0.625H17.5C17.9973 0.625 18.4742 0.822544 18.8258 1.17417C19.1775 1.52581 19.375 2.00272 19.375 2.5V17.5C19.375 17.9973 19.1775 18.4742 18.8258 18.8258C18.4742 19.1775 17.9973 19.375 17.5 19.375Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 8.125C7.28553 8.125 8.125 7.28553 8.125 6.25C8.125 5.21447 7.28553 4.375 6.25 4.375C5.21447 4.375 4.375 5.21447 4.375 6.25C4.375 7.28553 5.21447 8.125 6.25 8.125Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PhotoIcon;
